import { Box } from "@mui/material";
import { editPreferredEmail } from "components/app/App.slice";
import ThemeContext from "components/app/Context";
import { setOpenEmailDialog } from "components/features/dashboard/Dashboard.slice";
import { useTranslate } from "hooks/useTranslate";
import { useContext } from "react";
import { useAppDispatch } from "redux/hooks";
import { tokens } from "styles/Tokens";
import { accessTypes } from "utils/CommonConstants";
import { getLoggedInUserDetails } from "utils/CommonFunctions";
import Button from "./Button";
import Typography from "./Typography";

function PreferredEmailBanner() {
  const dispatch = useAppDispatch();
  const translate = useTranslate();
  const { isMobileScreen } = useContext(ThemeContext);
  const loggedInUserDetails = getLoggedInUserDetails();

  return (
    <>
      <Box
        padding={"16px 24px"}
        display={"flex"}
        flexDirection={"row"}
        sx={{
          backgroundColor: tokens.Border.General.LightColor,
          borderRadius: "8px",
          marginBottom: "20px",
          alignItems: "center"
        }}
      >
        <Typography
          showBold
          variant="body1"
          color={tokens.Icon.General.Inverse}
          children={
            loggedInUserDetails?.email
              ? translate("dashboard.PreferredEmailTitle") + loggedInUserDetails?.email
              : translate("dashboard.PreferredEmailDescription")
          }
        ></Typography>
        <Box marginLeft={"auto"} display={"flex"} flexDirection={isMobileScreen ? "column" : "row"} gap={"24px"}>
          <Button
            accessType={accessTypes.delete}
            variant="primaryWhite"
            onClick={() => dispatch(setOpenEmailDialog(true))}
            label={loggedInUserDetails?.email ? translate("dashboard.ChangeEmail") : translate("dashboard.UpdateEmail")}
          ></Button>
          <Button
            accessType={accessTypes.delete}
            sx={{ paddingX: "0px" }}
            variant="secondaryWhite"
            label={"Close"}
            onClick={() => {
              dispatch(editPreferredEmail({ preferredEmail: loggedInUserDetails?.email }));
            }}
          />
        </Box>
      </Box>
    </>
  );
}

export default PreferredEmailBanner;
